module.exports = __webpack_public_path__ + "assets/img/shop_detail_img1.bc671916.png";